/* eslint-disable import/no-cycle */
import { ArrowLeft } from 'phosphor-react';
import React, { useState } from 'react';
import { __ } from 'js/util';
import axios from 'axios';
import { CloseButton } from '../../CloseButton';
import { Loading } from '../../Loading';
import { ScreenshotButton } from '../ScreenshotButton';
import { feedbackTypes } from '..';

export function FeedbackContentStep({
  feedbackType,
  onFeedbackRestartRequested,
  onFeedbackSent,
}) {
  // const para armazenar a screenshot caso seja tirada.
  const [screenshot, setScreenshot] = useState(null);
  const [comment, setComment] = useState('');

  const [isSendingFeedback, setIsSendingFeedback] = useState(false);

  // só está pegando as informações da chave que foi enviada para o componente.
  const feedbackTypeInfo = feedbackTypes[feedbackType];

  async function handleSubmitFeedback(event) {
    event.preventDefault();
    setIsSendingFeedback(true);
    // TODO:enviar para o database
    await axios.post(global.route('support.mail'), {
      type: feedbackType,
      comment,
      screenshot,
    });
    setIsSendingFeedback(false);
    onFeedbackSent();
  }

  // TODO: Validar pq nao funciona com traducao
  // function handleTitle(title) {
  //   if (title === 'Problema') __('Problema');
  //   if (title === 'Ideia') __('Ideia');
  //   if (title === 'Outro') __('Outro');
  // }

  return (
    <>
      <header>

        <button
          type="button"
          className="top-5 left-5 absolute text-zinc-200 hover:text-white"
          onClick={onFeedbackRestartRequested}
        >
          <ArrowLeft weight="bold" className="w-4 h-4" />
        </button>

        <span className="text-xl text-zinc-100  text leading-6 flex items-center gap-2">
          <img
            src={feedbackTypeInfo?.image.source}
            alt={feedbackTypeInfo?.image.alt}
            className="h-6 w-6"
          />
          {/* {handleTitle(feedbackTypeInfo?.title)} */}
          {feedbackTypeInfo?.title}
        </span>

        <CloseButton />
      </header>
      <form onSubmit={handleSubmitFeedback} className="my-4 w-full">
        <textarea
          className="min-w-[304px] w-full min-h-[112px] text-sm placeholder-zinc-800 font-normal border-white bg-zinc-100 text-zinc-800 rounded-md focus:border-white focus:ring-white focus:ring-1 focus:outline-none resize-none scrollbar-thumb-white scrollbar-track-transparent scrollbar-thin "
          placeholder={__('Conte com detalhes o que está acontecendo...')}
          onChange={(event) => setComment(event.target.value)}
        />
        <footer className="flex gap-2 mt-2">
          <ScreenshotButton
            onScreenshotTook={setScreenshot}
            screenshot={screenshot}
          />
          <button
            type="submit"
            className="p-2 bg-primary-600 text-white rounded-md border-transparent flex-1 flex justify-center items-center text-sm hover:bg-primary-700 focus:outline-none focus:ring-offset-2 focus:ring-offset-white focus:ring-0 transition-colors disabled:hover:bg-primary-500 disabled:bg-primary-500 disabled:text-zinc-300 disabled:cursor-not-allowed"
            disabled={comment.length === 0 || isSendingFeedback}
          >
            {isSendingFeedback ? <Loading /> : __('Enviar Feedback')}
          </button>
        </footer>
      </form>
    </>
  );
}
